import { ChangeDetectorRef, Component } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { ContactTableComponent } from '../contact-table/contact-table.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Validators } from 'ngx-editor';
import { Router } from '@angular/router';
import { AppUtils } from '../../utlis/app-utils';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { CommonModule } from '@angular/common';
import { snackbarService } from '@one/web-components';
import { OneBreadcrumb } from '@one/angular-kit/navigation';
import { NotificationAuditTrailComponent } from '../notification-audit-trail/notification-audit-trail.component';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'dl-account-details',
  standalone: true,
  imports: [OneWebComponentsAngularModule,CommonModule,ContactTableComponent,ReactiveFormsModule,FormsModule,NotificationAuditTrailComponent],
  templateUrl: './account-details.component.html',
  styleUrl: './account-details.component.scss'
})
export class AccountDetailsComponent {

  public breadcrumbs: OneBreadcrumb[];
  public customerDataObj: any;
  public Status:any;
  public CustomerId: any;
  public customerTitle: any;
  public visibleAuditTrail: boolean = false;
  public isEditDisabled: boolean = false;
  public showEditControls: boolean = false;
  public customerData:any;
  public customerNotificationData: any;
  public CustomerDetails:any;
  public NotificationId:any;
  public userFileSize = { size: 0, type: '' };
  public userPermission: any;
  public isSetCom: boolean = false;
  public isNotiStat: boolean =false;
  public title: string = '';
  public accFormGroup: FormGroup;
  public accountDetails:any;
  public accountDataObj: any;
  public auditTrailDatafromAPI: any;
  public accountNotificationId:any;
  public accountFeedbackSubmissionDetails:any;
  public notificationCustomerDetails: any;
  public flag=true;
  public internalNoteDetails: any;
  inputData: { tableData: any; };
  public contactNotification: any;

  constructor(
    public appUtils: AppUtils,
    private fb: FormBuilder,
    private _cdr: ChangeDetectorRef,
    private qnsbnservice :QnSbnService,
    public _QnSbnService:QnSbnService,
    public _QnSbnDataService:QnSbnDataServiceService,
    public appUtil: AppUtils, 
    private router: Router,
     private snackBarNotification: SnackbarService
    
  ){}
  
  public ngOnInit(): void {
    console.log('%c AccountDetailsComponent ngOnInit', 'color: blue; font-weight: bold;');
    this.userPermission = this.qnsbnservice.getUserData();
    this.customerDataObj = history.state;
    this.customerData = this.customerDataObj.customerDetails.customerData;
    this.accountDataObj = this.customerData
    this.isSetCom = this.customerDataObj.customerDetails.isSetCom;
    this.isNotiStat = this.customerDataObj.customerDetails.notificationStatus;
    this.customerNotificationData = this.customerDataObj.customerDetails.notificationData;
    this.NotificationId = this.customerData.NotificationId;
    this.CustomerId = this.customerData.CustomerId;
    this.customerTitle = this.customerData.AccountName + " " + this.customerData.AccountId
    this.title = this.customerDataObj.customerDetails.notificationData.Title;
    this.contactNotification = this.customerDataObj.notificationDataObj.contactData;

    this.breadcrumbs = [
      {
        label: 'Notifications'
      },
      {
        label: this.customerNotificationData.LocalId
      },
      {
        label: this.customerData.AccountName + " " + this.customerData.AccountId
      }
    ];
    this.notificationCustomerDetails= this.customerDataObj.notificationDataObj.contactData[0];
    if (this.customerData.AccountStatus === "Feedback Received") {
      this.isEditDisabled = true;
    }
   
    this.accFormGroup = this.fb.group({
      formAccName: [null, [Validators.required]],
      formAccID: [null, [Validators.required]],
      formNote: [null]
    });

     let data=this.customerDataObj.notificationDataObj.contactData.filter(contact=>
      contact.hasOwnProperty('CustomerAddedFirstName')&&
      contact.hasOwnProperty('CustomerAddedLastName')&&
      contact.hasOwnProperty('CustomerAddedEmail')&&
      contact.hasOwnProperty('CustomerAddedCountry')&&
      contact.IsNonDialogUser==='TRUE'
    )

    if(data.length==1){
      this.accountFeedbackSubmissionDetails=data[0];
    }
    else if(data.length>1){
      let main=data[0];

      for(let i=1;i<data.length;i++){
      
        if(main.AccountFeedbackReceived<data[i].AccountFeedbackReceived){
          main=data[i];
        }
      }
      this.accountFeedbackSubmissionDetails=main;
    }
    else{
      this.accountFeedbackSubmissionDetails=[]
    }
  }

  

  openEditForm() {
    this.showEditControls = true;
    this.accFormGroup.controls['formAccID'].setValue(this.customerData.AccountId);
    this.accFormGroup.controls['formAccName'].setValue(this.customerData.AccountName);
    this.accFormGroup.controls['formNote'].setValue(this.customerData.NoteText);
  }

  editFormDetails() {
    let internalText =  this.accFormGroup.value.formNote;
    if(internalText.length > 500){
       this.snackBarMessage('alarm', 'Note is too long. Maximum length is 500 characters.');
    }else{
    this.accountDetails = {
      body:{
        "NewId": this.accFormGroup.value.formAccID,
        "NewName": this.accFormGroup.value.formAccName,
        "AccountNotificationId": this.customerData.AccountNotificationId
      }
    };
    const accountDetailsJson = JSON.stringify(this.accountDetails);
    this.qnsbnservice.EditAccountData(accountDetailsJson).subscribe(
      (response) => {
        if(response.statusCode === 200){
          this.customerData.AccountName = this.accFormGroup.value.formAccName;
          this.customerData.AccountId = this.accFormGroup.value.formAccID;
          this.closeEditForm();
          this._cdr.detectChanges();
           this.snackBarMessage('positive','Account data updated Successfully');
        }else{
          this.closeEditForm();
          this._cdr.detectChanges();
           this.snackBarMessage('alarm', 'Account ID or name already exists');
         
        }
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Account data updation Failed.');
      }
    );
     this.internalNoteDetails = {
          "NoteType": "Account",
          "NoteText" : this.accFormGroup.value.formNote,
          "NotificationId": this.customerDataObj.customerDetails.notificationData.NotificationId || "",
          "AccountNotificationId": this.customerData.AccountNotificationId || "",
          "userId": this.customerDataObj.customerDetails.notificationData.UserId || "",
          "userRole":this.customerDataObj.customerDetails.notificationData.UserRole || ""
      }
        this.qnsbnservice.saveInternalNote(this.internalNoteDetails).subscribe(
        (response) => {
          if(response.$metadata?.httpStatusCode === 200){
             if(this.customerData?.NoteText !== this.accFormGroup.value.formNote){
                this.customerData.NoteDate = new Date();
              }
              this.customerData.NoteText = this.accFormGroup.value.formNote;
              this._cdr.detectChanges();
              this.closeEditForm();
          }else{
            this.closeEditForm();
            this._cdr.detectChanges();
          }
        },
        (error: HttpErrorResponse) => {
          this.qnsbnservice.httpErrorHandler(error, 'Note updation failed');
        }
      );
    
  }}

  closeEditForm() {
    this.showEditControls = false;
  }

  public bytesCalculation(bytes: number, decimals: number = 2): any {
    if (bytes === 0) {
      this.userFileSize.size = 0;
      this.userFileSize.type = '';
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    this.userFileSize.size = 0;
    this.userFileSize.type = '';

    this.userFileSize.size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    this.userFileSize.type = sizes[i];
    return this.userFileSize;
  }

  public formatBytes(bytes: number, decimals: number = 2): string {
    this.bytesCalculation(bytes, decimals);
    return this.userFileSize.size + ' ' + this.userFileSize.type;
  }

  public displayStatus(status) {
    const statusText = status ? status : 'Pending';
    return statusText;
  }

  public downloadDocument(globalNotificationId: string, fileExtension: string) {
    this.qnsbnservice.downloadPiosDocumentApi(globalNotificationId, fileExtension);
  }
  
  public downloadAttachment(fileName: string, notificationId: string, accountNotificationId?: string, attachment?: string) {
    if(accountNotificationId && attachment){
      this.qnsbnservice.downloadLocalAttachmentApi(fileName, notificationId, accountNotificationId, attachment);
    }else{
       this.qnsbnservice.downloadLocalAttachmentApi(fileName, notificationId);
    }
   
  }
  
  private createCleanData(obj: any): any {
    if (!obj) return {};
    
    try {
      const visited = new WeakSet();
      
      const deepClone = (value: any): any => {
        // Handle primitive types
        if (value === null || typeof value !== 'object') {
          return value;
        }
        
        // Prevent circular references
        if (visited.has(value)) {
          return undefined;
        }
        
        // Handle arrays
        if (Array.isArray(value)) {
          visited.add(value);
          const arr = value.map(item => deepClone(item)).filter(item => item !== undefined);
          visited.delete(value);
          return arr;
        }
        
        // Handle dates
        if (value instanceof Date) {
          return value.toISOString();
        }
        
        // Handle objects
        visited.add(value);
        const cloned = {};
        
        for (const key in value) {
          if (value.hasOwnProperty(key)) {
            const prop = value[key];
            
            // Skip functions and undefined values
            if (typeof prop === 'function' || prop === undefined) {
              continue;
            }
            
            // Recursively clone safe properties
            if (prop === null || typeof prop !== 'object') {
              cloned[key] = prop;
            } else if (Array.isArray(prop)) {
              cloned[key] = prop.map(item => deepClone(item)).filter(item => item !== undefined);
            } else if (!(prop instanceof Date) && !visited.has(prop)) {
              cloned[key] = deepClone(prop);
            }
          }
        }
        
        visited.delete(value);
        return cloned;
      };
      
      return deepClone(obj);
    } catch (error) {
      console.error('Error creating clean data:', error);
      // Return basic fallback
      return {};
    }
  }

  gotoNotificationDetailsPage(event){
    event.preventDefault();
    event.stopPropagation();
    this.qnsbnservice.getNotificationContactDetails(this.NotificationId).subscribe(
      (data:any) => {
        this._QnSbnService.getAccountList(this.NotificationId).subscribe(
          res =>{
            // Clean data to prevent circular references
            const cleanNotificationData = this.createCleanData(this.customerNotificationData);
            const cleanContactData = this.createCleanData(data);
            const cleanAccountData = this.createCleanData(res?.body);

            this.router.navigate(['/notification-details'], { 
              state: { 
                notificationData: cleanNotificationData, 
                contactData: cleanContactData, 
                accountDataObj: cleanAccountData 
              } 
            });
          },
          (err: HttpErrorResponse) => {
            this._QnSbnService.httpErrorHandler(err, 'Could not fetch Account Data');
          }
        );
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Could not fetch contact details.');
        this.router.navigate(['/notification-details'], { 
          state: { 
            notificationData: this.createCleanData(this.customerNotificationData), 
            contactData: [], 
            accountDataObj: [] 
          } 
        });
      }
    );
  }
  
  gotoNotificationPage(event){
     event.preventDefault();
    event.stopPropagation();
    this.router.navigate(['/notification']);
  }

  public viewAuditTrail(){
    this.accountNotificationId=this.customerData?.AccountNotificationId;
    this.qnsbnservice.getAccountNotificationAuditTrailList(this.accountNotificationId).subscribe(
      res =>{
        this.auditTrailDatafromAPI=res;
        this.inputData = {
          tableData: this.auditTrailDatafromAPI
        };
        this.visibleAuditTrail = true;
        this._cdr.detectChanges();
      },
      err =>{
        this.snackBarMessage('alarm', 'Failed to fetch Audit Trail Data');
      }
    );
  }

   public isNoAttachmentsVisible(): boolean {
    const hasLocalAttachments = this.customerNotificationData?.NotificationAttachments && 
    this.customerNotificationData.NotificationAttachments.length > 0;
    
    const hasGlobalAttachments = this.customerNotificationData?.DocumentEnabled === true &&
    this.customerNotificationData?.NotificationDocuments &&
    this.customerNotificationData.NotificationDocuments.length > 0 &&
    this.customerNotificationData.NotificationDocuments[0]?.Title;
        
    return !hasLocalAttachments && !hasGlobalAttachments;
  }

   snackBarMessage(status: any, message: string) {
      snackbarService.show({
        message: message,
        snackbarProps: {
          status: status,
          direction: 'horizontal',
          showClose: true,
          elevated: false,
          duration: 5000,
          verticalPlacement: 'top',
          horizontalPlacement: 'right',
        }
      });
    }
}

